export interface IssueType {
  anecdotes_id: string;
  description: string;
  id: string;
  name: string;
}

export interface Project {
  anecdotes_id: string;
  id: string;
  key: string;
  name: string;
  issue_types: IssueType[];
}

export interface BaseMetadata {
  projects?: Project[];
}

export interface DaysAgoOption {
  display_name: string;
  value: string;
}

export const DaysAgoOptions: DaysAgoOption[] = [
  { display_name: '7 Days', value: '7d' },
  { display_name: '14 Days', value: '14d' },
  { display_name: '1 Month', value: '1m' },
  { display_name: '3 Months', value: '3m' },
  { display_name: '6 Months', value: '6m' }
];

// Collaboration related interfaces

export enum TaskCreationFormFieldTypes {
  ARRAY = 'ARRAY',
  STRING = 'STRING',
  TEXTAREA = 'TEXTAREA',
  MULTIARRAY = 'MULTIARRAY',
  DATE = 'DATE',
  EMAIL = 'EMAIL',
  RICHTEXT = 'RICHTEXT',
  USERS_LIST = 'USERS_LIST'
}
export interface FormFieldOption {
  id: number | string;
  value: string;

  // This value is extension
  only_id?: boolean;
  error_if_any?: string;
}

export interface StaticCreateTaskFormItem {
  field_key: string;
  field_name: string;
  field_type: TaskCreationFormFieldTypes;
  field_options: FormFieldOption[];
  /**
   * Reflects fields nesting of Collaboration entity, path to end are separated by dots. Ex: 'collaboration_assignee.name'
   */
  field_path_to_value: string;
  is_required: boolean;
  suggestion_key: string;
  only_id: boolean;
  error_if_any?: string;
}

export interface DynamicCreateTaskFormItem {
  [key: string]: CreateTaskForms;
}

export interface CreateTaskForms {
  static_form: StaticCreateTaskFormItem[];
  dynamic_form: DynamicCreateTaskFormItem;
}

export const CreateTicketFormDescriptionPropName = 'createTicketFormDescription';

// Collaboration item view metadata
export const PreviewTaskContentDefinitions = 'taskPreviewDescription';
export const EvidenceRequestTaskContentDefinitions = 'evidenceRequestPreviewDescription';
export const TaskMyAnecdotesPreviewDescriptionDefinitions = 'taskMyAnecdotesPreviewDescription';
export const EvidenceRequestMyAnecdotesViewDefinitions = 'evidenceRequestMyAnecdotesView';

export type CollaborationContentDefenitionType =
  | 'taskPreviewDescription'
  | 'evidenceRequestPreviewDescription'
  | 'taskMyAnecdotesPreviewDescription'
  | 'evidenceRequestMyAnecdotesView';

export enum TaskViewFieldTypesEnum {
  DATE = 'DATE',
  USER = 'USER',
  STATUS = 'STATUS',
  TEXTAREA = 'TEXTAREA',
  STRING = 'STRING',
  RICHTEXT = 'RICHTEXT',
}

export enum MyAnecdotesTaskPreviewSectionIds {
  Collapsed = 'collapsed',
  ExpandedRow = 'expand',
  ExpandedBigItems = ' description',
}

export enum TaskPreviewOptionsIds {
  TaskOwner = 'avatar',
}

export interface TaskPreviewOptions {
  id: string;
  link?: string;
  value: string;
}

export interface TaskViewDefinitionField {
  field_id: string;
  field_options: TaskPreviewOptions[];
  /**
  Reflects fields nesting of Collaboration entity, path to end are separated by dots. Ex: 'collaboration_assignee.name'
   */
  field_path_to_value: string;
  field_title: string;
  field_type: TaskViewFieldTypesEnum;
  is_editable: boolean;
  should_exist_when_done: boolean;
}

export interface TaskContentDefinitions {
  is_refreshable: boolean;
  is_title_editable: boolean;
  preview_sections: {
    section_fields: TaskViewDefinitionField[];
    section_type?: MyAnecdotesTaskPreviewSectionIds;
  }[];
}

export interface ServiceMetadata extends BaseMetadata {
  [CreateTicketFormDescriptionPropName]?: CreateTaskForms;
  [PreviewTaskContentDefinitions]?: TaskContentDefinitions;
  [EvidenceRequestTaskContentDefinitions]?: TaskContentDefinitions;
  [TaskMyAnecdotesPreviewDescriptionDefinitions]?: TaskContentDefinitions;
  [EvidenceRequestMyAnecdotesViewDefinitions]?: TaskContentDefinitions;
}
